var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.2L5 6.39L10 3.2L5 0L0 3.2ZM10 3.2L15 6.39L20 3.2L15 0L10 3.2ZM0 9.55L5 12.74L10 9.55L5 6.35L0 9.55ZM15 6.35L10 9.55L15 12.74L20 9.55L15 6.35ZM5.03 13.8L10.04 17L15.04 13.8L10.04 10.61L5.03 13.8Z",
    fill: "black",
    fillOpacity: 0.64
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.76c7d328adac0dbf57c4fa4296183915.svg";
export { ForwardRef as ReactComponent };